import React, { useState } from "react";
import { BiSolidPhoneCall } from "react-icons/bi";
import { FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { TiLocation } from "react-icons/ti";
import bannerImage from "../../asset/contact banner image.png";
import { NavLink } from "react-router-dom";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useCreateContactUsMutation } from "../../Redux/getApi";
import { ReactSVG } from "react-svg";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from "react-toastify";

const CustomInput = React.forwardRef((props, ref) => (
  <input
    {...props}
    ref={ref}
    style={{
      ...props.style,
      outline: "none",
    }}
  />
));
const ContactUs = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    subject: "",
    message: "",
  });
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);

  const [createContactUs, { isLoading }] = useCreateContactUsMutation();

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    address: "",
    subject: "",
    message: "",
    phone: "",
  });

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      valid = false;
    } else {
      newErrors.name = "";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email.";
      valid = false;
    } else {
      newErrors.email = "";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required.";
      valid = false;
    } else {
      newErrors.address = "";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required.";
      valid = false;
    } else {
      newErrors.subject = "";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
      valid = false;
    } else {
      newErrors.message = "";
    }

    if (phone) {
      if (typeof phone === "string" && !isValidPhoneNumber(phone)) {
        newErrors.phone = "Please enter the valid phone number";

        valid = false;
      } else {
        newErrors.phone = "";
      }
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [phone, setPhone] = useState("");

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    if (!executeRecaptcha) {
      toast.error(
        "Unable to start security verification. Please refresh the page and try again."
      );
      return;
    }

    const contactUsData = {
      name: formData.name,
      email: formData.email,
      phone,
      address: formData.address,
      subjects: formData.subject,
      message: formData.message,
    };

    try {
      const recaptchaToken = await executeRecaptcha("contact_us_form");
      const response = await createContactUs({
        ...contactUsData,
        recaptchaToken,
      }).unwrap();
      if (response.success) {
        setIsOpenSuccess(true);
        toast.success(response.message || "Message sent successfully!");
        handleCancel();
      } else {
        setIsOpenError(true);
      }
    } catch (err) {
      setIsOpenError(true);
      const errorMsg =
        err?.data?.message ||
        err?.data?.error ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "An unexpected error occurred";
      toast.error(errorMsg);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      email: "",
      address: "",
      subject: "",
      message: "",
    });
    setPhone("");
    setErrors({
      name: "",
      email: "",
      address: "",
      subject: "",
      message: "",
      phone: "",
    });
  };
  return (
    <>
      <div className="flex flex-col gap-10 lg:py-20 md:py-14 sm:py-10 py-6 xl:px-[5%] lg:px-[3%] md:px-[3%] px-[4%] ">
        <div>
          <h1 className="md:text-[2.5rem] text-[1.8rem] font-bold text-center">
            Contact Us
          </h1>{" "}
          <p className="md:text-[1.3rem] text-[1rem] text-center ">
            Get in touch with Rawalpindi Development Authority – We’re{" "}
            <br className="sm:block hidden" /> here to assist you with your
            queries and concerns.
          </p>
        </div>
        <div className="flex lg:flex-row flex-col lg:items-start items-center w-full gap-6">
          <div className="lg:flex-1 w-full bg-[#F0F0F0] rounded-2xl md:p-6 p-4 flex flex-col md:gap-8 gap-4">
            <h1 className="md:text-[2.3rem] text-[1.6rem] font-semibold">
              Get In Touch With Us
            </h1>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col items-start md:gap-8 gap-4"
            >
              <div className="grid sm:grid-cols-2 grid-cols-1 items-center w-full gap-4">
                <div className="flex flex-col md:gap-1 gap-[2px]">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className=" w-full outline-none p-3 rounded-xl text-[#A6A6A6]"
                    placeholder="Name"
                  />
                  {errors.name && (
                    <p className="text-red-500 md:text-sm text-[12px]">
                      {errors.name}
                    </p>
                  )}
                </div>
                <div className="flex flex-col md:gap-1 gap-[2px]">
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className=" w-full outline-none p-3 rounded-xl text-[#A6A6A6]"
                    placeholder="Email"
                  />
                  {errors.email && (
                    <p className="text-red-500 md:text-sm text-[12px]">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid sm:grid-cols-2 grid-cols-1 items-start w-full gap-4">
                <div className="flex flex-col md:gap-1 gap-[2px]">
                  <PhoneInput
                    international
                    // defaultCountry="PK"
                    value={phone}
                    onChange={handlePhoneChange}
                    className="w-full p-3 rounded-xl text-[#A6A6A6] bg-white outline-none"
                    inputComponent={CustomInput}
                  />
                  {errors.phone && (
                    <p className="text-red-500 md:text-sm text-[12px]">
                      {errors.phone}
                    </p>
                  )}
                </div>
                <div className="flex flex-col md:gap-1 gap-[2px]">
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className=" w-full outline-none p-3 rounded-xl text-[#A6A6A6]"
                    placeholder="Address"
                  />
                  {errors.address && (
                    <p className="text-red-500 md:text-sm text-[12px]">
                      {errors.address}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex flex-col md:gap-1 gap-[2px] w-full">
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className=" w-full outline-none p-3 rounded-xl text-[#A6A6A6]"
                  placeholder="Subject"
                />
                {errors.subject && (
                  <p className="text-red-500 md:text-sm text-[12px]">
                    {errors.subject}
                  </p>
                )}
              </div>
              <div className="flex flex-col md:gap-1 gap-[2px] w-full">
                <textarea
                  rows="8"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className=" w-full outline-none p-3 rounded-xl text-[#A6A6A6]"
                  placeholder="Write a message"
                ></textarea>
                {errors.message && (
                  <p className="text-red-500 md:text-sm text-[12px]">
                    {errors.message}
                  </p>
                )}
              </div>
              <button
                type="submit"
                disabled={isLoading || !executeRecaptcha}
                className=" text-white bg-[#00643b] py-2 px-6 rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center"
              >
                {isLoading ? (
                  <>
                    <svg
                      class="mr-1 size-4 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Sending Message...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
          <div className="lg:flex-1 flex flex-col md:gap-8 gap-4 md:p-6 p-4">
            <div className=" flex flex-col gap-3">
              <h1 className="md:text-[2.3rem] text-[1.6rem] font-semibold">
                Contact Details
              </h1>
              <p className="md:text-[1.3rem] text-[1rem]">
                Deputy Director (Public Relations) Mr. Hafiz Muhammad Irfan has
                been nominated as Public Information Officer 051-5555662
              </p>
            </div>
            <div className=" grid sm:grid-cols-2 grid-cols-1 gap-6">
              <div className="flex gap-2 items-center">
                <div className=" bg-[#00643b] p-2 rounded-lg">
                  <BiSolidPhoneCall className="md:size-10 size-8 text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="md:text-[1.1rem] text-[.9rem] font-medium">
                    Phone Number
                  </span>
                  <span className="text-[#777777] md:text-[0.8rem] text-[.7rem]">
                    051-5555490-92
                  </span>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <div className=" bg-[#00643b] p-2 rounded-lg">
                  <MdEmail className="md:size-10 size-8 text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="md:text-[1.1rem] text-[.9rem] font-medium">
                    Email
                  </span>
                  <span className="text-[#777777] md:text-[0.8rem] text-[.7rem]">
                    info@rda.gop.pk
                  </span>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <div className=" bg-[#00643b] p-2 rounded-lg">
                  <TiLocation className="md:size-10 size-8 text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="md:text-[1.1rem] text-[.9rem] font-medium">
                    Address
                  </span>
                  <span className="text-[#777777] md:text-[0.8rem] text-[.7rem]">
                    RDA Headquarters Murree Road Near Liaqat Bagh, Rawalpindi,
                    Pakistan
                  </span>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="md:text-[1.3rem] text-[1.1rem] font-semibold">
                Social Media:
              </span>
              <div className="flex items-center sm:gap-5 gap-3">
                <NavLink
                  to={"https://web.facebook.com/RawalpindiDevelopmentAuthority"}
                  target="_blank"
                  className="sm:p-2 p-1.5 bg-[#00643b] rounded-full"
                >
                  <FaFacebookF className="sm:size-6 size-5 text-white" />
                </NavLink>
                <NavLink
                  to={"https://twitter.com/RdaRawalpindi"}
                  target="_blank"
                  className="sm:p-2 p-1.5 bg-[#00643b] rounded-full"
                >
                  <FaTwitter className="sm:size-6 size-5 text-white" />
                </NavLink>
                <NavLink
                  to={"https://www.youtube.com/@rawalpindidevelopmentauthority"}
                  target="_blank"
                  className="sm:p-2 p-1.5 bg-[#00643b] rounded-full"
                >
                  <FaYoutube className="sm:size-6 size-5 text-white" />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className=" mt-16  bg-cover bg-center hidden md:flex lg:gap-10 gap-6 bg-contact-banner rounded-2xl lg:p-8 lg:pb-0 p-4 pb-0 ">
          <div className="lg:w-[65%] w-[70%] flex flex-col xl:gap-6 lg:gap-4 gap-2 text-white">
            <h1 className=" xl:text-[2.3rem] lg:text-[1.8rem] text-[1.3rem] font-bold">
              RDA’S Complaint Management System
            </h1>
            <p className="xl:text-[1.2rem] lg:text-[1rem] text-[.8rem]">
              The Rawalpindi Development Authority (RDA) through its online
              portal has made it easy for residents of Rawalpindi to register
              any grievances related to basic civic issues. There is a specific
              page – RDA’s Complaint Management System – where people can lodge
              their complaints anytime, anywhere.
            </p>

            <NavLink className=" bg-[#00643B] lg:py-2 py-1 px-5 w-max lg:text-[1.3rem] text-[.9rem] font-medium rounded-lg">
              Lodge a Complaint
            </NavLink>
          </div>
          <div className="lg:w-[35%] w-[30%]">
            <img src={bannerImage} className="w-[95%] ml-[10%]" alt="" />
          </div>
        </div>
      </div>
      {isOpenSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-[#fff] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
            <div className=" w-[full] flex justify-center items-center flex-col gap-3">
              <ReactSVG
                src={"/icon/success.svg"}
                className={`size-12 text-[#00643b]`}
              />
              <span className=" capitalize text-[#00643b] font-semibold leading-none">
                success!
              </span>
              <span className=" text-center">
                Thanks for reaching out! We’ve received your message and will
                get back to you shortly.
              </span>
            </div>
            <div className="w-full">
              <button
                onClick={() => setIsOpenSuccess(false)}
                className=" bg-gradient-to-r from-[#00643b70] to-[#00643b] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpenError && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 backdrop-blur-sm">
          <div className="bg-[#fff] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
            <div className=" w-[full] flex justify-center items-center flex-col gap-3">
              <ReactSVG
                src={"/icon/error.svg"}
                className={`text-[#e93749] size-12`}
              />

              <span className=" capitalize text-[#e93749] font-semibold leading-none">
                error!
              </span>
              <span className=" text-center">
                Oops! Something went wrong. Please check your details and try
                again, or refresh the page and resubmit your information. If the
                error persists please contact support at{" "}
                <NavLink
                  to="mailto:info@rda.gop.pk"
                  className={"text-green-500 "}
                  target="_blank"
                >
                  info@rda.gop.pk
                </NavLink>
              </span>
            </div>
            <div className="w-full">
              <button
                onClick={() => setIsOpenError(false)}
                className=" bg-gradient-to-r from-[#00643b70] to-[#00643b] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUs;
